import { NgOptimizedImage } from '@angular/common'
import { ChangeDetectionStrategy, Component, DOCUMENT, inject, OnInit, signal } from '@angular/core'
import { Router, RouterLink, RouterLinkActive } from '@angular/router'
import { AppConfigService } from '@mos/client/shared/app-config'
import { ButtonComponent } from '@mos/client/web/core/components/button/button.component'
import { logoDimensions } from '@mos/client/web/core/texts/logo'
import { SocialLinksComponent } from '../../components/social-links/social-links.component'

@Component({
	selector: 'mos-landing-burger-menu',
	imports: [NgOptimizedImage, RouterLinkActive, ButtonComponent, SocialLinksComponent, RouterLink],
	templateUrl: './landing-burger-menu.component.html',
	styleUrls: ['./landing-burger-menu.component.scss'],
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class LandingBurgerMenuComponent implements OnInit {
	protected readonly logo = logoDimensions
	configService = inject(AppConfigService)
	document = inject(DOCUMENT)
	router = inject(Router)

	active = signal(false)

	closeMenu(): void {
		this.active.set(false)
		this.setBodyClass()
	}

	toggleBurgerMenu() {
		this.active.set(!this.active())
		this.setBodyClass()
	}

	ngOnInit(): void {
		this.setBodyClass()
	}

	private setBodyClass() {
		if (this.active()) {
			this.document.body.classList.add('no-scroll')
		} else {
			this.document.body.classList.remove('no-scroll')
		}
	}
}
